export class TimelineSlide {
    year?: number;
    month?: number;
    constructor(data?: TimelineSlide) {
        this.year = data?.year;
        this.month = data?.month;
    }
}

export const MONTHS: string[] = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
];